export default "__VITE_ASSET__DcH8NVJZ__"